import { ProductVariationsSearchGetSortEnum } from "@/web-client";

export const formatSortByProductVariation = (value: string): string => {
  switch (value) {
    case ProductVariationsSearchGetSortEnum.Recommend:
      return "おすすめ";

    case ProductVariationsSearchGetSortEnum.PriceAsc:
      return "価格が安い";

    case ProductVariationsSearchGetSortEnum.PriceDesc:
      return "価格が高い";

    case ProductVariationsSearchGetSortEnum.SampleRequestsRecentDesc:
      return "サンプル請求が多い（月間）";

    case ProductVariationsSearchGetSortEnum.SampleRequestsTotalDesc:
      return "サンプル請求が多い（累計）";
  }
};
